import { gql } from '@apollo/client';

const INITIATE_DOCUMENT_VERIFICATION = gql`
  mutation InitiateDocumentVerification(
    $input: InitiateDocumentVerificationInput!
  ) {
    initiateDocumentVerification(input: $input) {
      url
    }
  }
`;

export { INITIATE_DOCUMENT_VERIFICATION };
